import React, { useState, useCallback, useEffect } from 'react';
import tenantsService from 'src/services/tenantService';
import bpartnerService from 'src/services/bpartnerService';
import userInfo from 'src/services/userInfo';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	img: {
		width: '100%'
	}
}))

function LogoCobranding({ size, ...props }) {
	const classes = useStyles();
	const isMountedRef = useIsMountedRef();
	const [logoCobranding, setLogoCobranding] = useState(null);

	const getLogoCobranding = useCallback(() => {
		if (!props?.src)
			userInfo.getLogoCobranding(size).then(r => {
				if (r!=null)
					setLogoCobranding(r);
			});
	}, [isMountedRef])
	
	useEffect(() => {
		getLogoCobranding(size);
	}, [getLogoCobranding])  

	if (!logoCobranding && !props?.src) return null;
	
	return (
		<img
			alt="Logo"
			src={logoCobranding}
			className={classes.img}
			{...props}
		/>
	);
	
}

export default LogoCobranding;
